import React, { useState } from "react";

export default function Tutorial() {
  const videos = [
    {
      id: 1,
      src: "https://www.youtube.com/embed/NC5a2RGcQ9g",
      title: "Tutorial Video 1",
    },
    {
      id: 2,
      src: "https://www.youtube.com/embed/jqwnxapOnUg",
      title: "Tutorial Video 2",
    },
    {
      id: 3,
      src: "https://www.youtube.com/embed/cIxYCrEaRtc",
      title: "Tutorial Video 3",
    },
    {
      id: 4,
      src: "https://www.youtube.com/embed/tiOclZhVjZU",
      title: "Tutorial Video 4",
    },
    {
      id: 5,
      src: "https://www.youtube.com/embed/EQuk44_Zzcs",
      title: "Tutorial Video 5",
    },
  ];

  const [loadedVideos, setLoadedVideos] = useState({});

  const handleVideoLoad = (id) => {
    setLoadedVideos((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <div>
      <div className="container my-5">
        <div className="navbar-brand fs-4 fw-semibold text-dark my-3">
          Video Tutorial Database Vendor & Broadcast Woowa
        </div>
        <div className="row justify-content-center g-4">
          {videos.map((video) => (
            <div className="col-md-6" key={video.id}>
              <div className="position-relative ratio ratio-16x9 rounded overflow-hidden">
                {!loadedVideos[video.id] && (
                  <div className="w-100 h-100 placeholder-glow bg-secondary bg-opacity-25">
                    <div className="placeholder w-100 h-100"></div>
                  </div>
                )}

                <iframe
                  src={video.src}
                  title={video.title}
                  allowFullScreen
                  onLoad={() => handleVideoLoad(video.id)}
                  style={{
                    opacity: loadedVideos[video.id] ? 1 : 0,
                    transition: "opacity 0.5s ease-in-out",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: "none",
                  }}
                ></iframe>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
